import "./_photo.scss";
import { useContext } from "react";
// provider data
import { PhotoProviderData } from "./Provider";
// components
import { Tab, ControlPanel } from "@shared/src";
// 사진 리스트 노출 제어 패널

// 사진 탭 (공식이미지, 리뷰이미지)
export const PhotoTab = () => {
  // provider data
  const { activePhotoTab, setActivePhotoTab } = useContext(PhotoProviderData).data;
  // 공식이미지 0, 리뷰이미지 1

  return (
    <>
      <ControlPanel
        className="photo-list-tab"
        left={
          <Tab
            type="r50"
            detailType="brown"
            tabs={[{ label: "공식이미지" }, { label: "리뷰이미지" }]}
            onSelect={(index) => {
              setActivePhotoTab(index);
            }}
          />
        }
      />
    </>
  );
};
